import { YStack } from 'tamagui';

import PSText from './ui/PSText';

/** The first-timer's pitch, on home's Access Pass block and the Access Pass page. White on `$brandDark`. */
export default function AccessPassIntro() {
  return (
    <YStack gap={'$space.lg'}>
      <PSText.H3 color={'$color.brandSecondary'}>Introducing</PSText.H3>
      <YStack gap={'$space.xs'}>
        {/* No 32px role; Figma's Xxl. */}
        <PSText.Title
          color={'$color.textWhite'}
          fontSize={'$xxl'}
          lineHeight={42}
        >
          The Putting Scene Access Pass!
        </PSText.Title>
        <PSText.Body1 color={'$color.textWhite'}>
          Your key to Bangalore’s hardest doors. It unlocks tables the city’s
          fighting for, and experiences that exist nowhere else.
        </PSText.Body1>
      </YStack>
    </YStack>
  );
}
